import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UpcomingBatches.css'; // Import the CSS file
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import API_URL from '../../api/ExamCalendarApi';
const UpcomingBatches = () => {
  const [batches, setBatches] = useState([]);
  const [branch, setBranch] = useState('');
  const [course, setCourse] = useState('');
  const [startDate, setStartDate] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [editingBatch, setEditingBatch] = useState(null);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const fetchBatches = async () => {
    try {
      const response = await axios.get(`${API_URL}/batches/get-upcoming-batches`);

      // Sort batches in descending order by StartDate
      const sortedBatches = response.data.batches.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate));

      setBatches(sortedBatches); // Update the batches state with sorted data
    } catch (error) {
      console.error('Error fetching batches:', error);
      setError('Failed to fetch batches');
    }
  };


  useEffect(() => {
    fetchBatches();
  }, []);

const handleCreate = async (e) => {
  e.preventDefault();
  if (!branch || !course || !startDate || !contactNumber) {
    alert('Please fill in all fields');
    return;
  }

  try {
    const newBatch = { Branch: branch, Course: course, StartDate: startDate, ContactNumber: contactNumber };
    await axios.post(`${API_URL}/batches/add-upcoming-batch`, newBatch);
    setSuccessMessage('Batch added successfully!');
    fetchBatches(); // Fetch and sort the batches again
    setBranch('');
    setCourse('');
    setStartDate('');
    setContactNumber('');
  } catch (error) {
    console.error('Error creating batch:', error);
    setError('Failed to create batch');
  }
};

const handleUpdate = async (e) => {
  e.preventDefault();
  if (!branch || !course || !startDate || !contactNumber) {
    alert('Please fill in all fields');
    return;
  }

  try {
    const updatedBatch = { Branch: branch, Course: course, StartDate: startDate, ContactNumber: contactNumber };
    await axios.put(`${API_URL}/batches/update-upcoming-batch/${editingBatch._id}`, updatedBatch);
    setSuccessMessage('Batch updated successfully!');
    fetchBatches(); // Fetch and sort the batches again
    setEditingBatch(null);
    setBranch('');
    setCourse('');
    setStartDate('');
    setContactNumber('');
  } catch (error) {
    console.error('Error updating batch:', error);
    setError('Failed to update batch');
  }
};

  const handleEdit = (batch) => {
    setEditingBatch(batch);
    setBranch(batch.Branch);
    setCourse(batch.Course);
    setStartDate(batch.StartDate);
    setContactNumber(batch.ContactNumber);
  };



  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/batches/delete-upcoming-batch/${id}`);
      setSuccessMessage('Batch deleted successfully!');
      fetchBatches();
    } catch (error) {
      console.error('Error deleting batch:', error);
      setError('Failed to delete batch');
    }
  };

  const handleDeleteAll = async () => {
    try {
      await axios.delete(`${API_URL}/batches/delete-all-upcoming-batches`);
      setSuccessMessage('All batches deleted successfully!');
      fetchBatches();
    } catch (error) {
      console.error('Error deleting all batches:', error);
      setError('Failed to delete all batches');
    }
  };

  return (
    <div className='admin-upcomingbatches-container'>
      <div className='admin-upcomingbatches-section'>
        <BannerUpdate pageName="upcoming-batches-banner" />
        <h1>Upcoming Batches</h1>


        {error && <div className='admin-upcomingbatches-alert admin-upcomingbatches-danger'>{error}</div>}
        {successMessage && <div className='admin-upcomingbatches-alert admin-upcomingbatches-success'>{successMessage}</div>}

        <form onSubmit={editingBatch ? handleUpdate : handleCreate} className="admin-upcomingbatches-form">
          <div className="admin-upcomingbatches-form-group">
            <label>Branch</label>
            <input
              type="text"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              placeholder="Enter branch"
            />
          </div>
          <div className="admin-upcomingbatches-form-group">
            <label>Course</label>
            <input
              type="text"
              value={course}
              onChange={(e) => setCourse(e.target.value)}
              placeholder="Enter course"
            />
          </div>
          <div className="admin-upcomingbatches-form-group">
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="admin-upcomingbatches-form-group">
            <label>Contact Number</label>
            <input
              type="text"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
              placeholder="Enter contact number"
              pattern="[0-9]{10}"
              title="Mobile number must be 10 digits"
            />
          </div>
          <button type="submit" className="admin-upcomingbatches-submit">
            {editingBatch ? 'Update Batch' : 'Add Batch'}
          </button>
        </form>

        <button onClick={handleDeleteAll} className="admin-upcomingbatches-delete-all">
          Delete All Batches
        </button>
        <div className="admin-upcomingbatches-table-wrapper">
          <table className="admin-upcomingbatches-table">
            <thead>
              <tr>
                <th>Branch & Course</th>
                <th>Start Date</th>
                <th>Contact</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch) => (
                <tr key={batch._id}>
                  <td>
                    <strong>{batch.Branch}</strong> - {batch.Course}
                  </td>
                  <td>{new Date(batch.StartDate).toLocaleDateString()}</td> {/* Format the date here */}
                  <td>{batch.ContactNumber}</td>
                  <td>
                    <button onClick={() => handleEdit(batch)} className="admin-upcomingbatches-edit">
                      Edit
                    </button>
                    <button onClick={() => handleDelete(batch._id)} className="admin-upcomingbatches-delete">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UpcomingBatches;
